<div class="writing-indication">
    <p-icon *ngIf="state !== 'completed'" name="ai-thinking" size="sm"></p-icon>
    <p-icon *ngIf="state === 'completed'" name="ai-check-circle" size="sm" color="supportive-success"></p-icon>
    <span class="thinking-event-label">{{ translationKey | translate: translationParams }}</span>
</div>
